/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ComponentDefinitionLegacyTypeDto = {
    CateringPackages: 'CATERING_PACKAGES',
    BeveragePackages: 'BEVERAGE_PACKAGES',
    Product: 'PRODUCT',
    Room: 'ROOM',
    Transport: 'TRANSPORT',
    Decoration: 'DECORATION',
    Service: 'SERVICE',
    Equipment: 'EQUIPMENT',
    Staffing: 'STAFFING',
} as const;

export type ComponentDefinitionLegacyTypeDto = typeof ComponentDefinitionLegacyTypeDto[keyof typeof ComponentDefinitionLegacyTypeDto];



